import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/ReportSettings'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class ReportSettingsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "ReportSettingsStore",
			variables: false,
		})
	}
}

export async function load_ReportSettings(params) {
  await initClient()

	const store = new ReportSettingsStore()

	await store.fetch(params)

	return {
		ReportSettings: store,
	}
}
